import React from 'react';
import { useSelector } from 'react-redux';

import {
  LinearProgressMainLayoutActivate,
  LinearProgressMainLayoutDeactivate,
} from '#app/Action/LinearProgressMainLayoutAction';
import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import { hasRight } from '#app/Common/UserCommon';
import ContentViewComponent from '#app/Component/ContentViewComponent';
import IconAction from '#app/Component/IconAction';
import TableComponent from '#app/Component/TableComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { getRoutePathname } from '#app/Handler/RouteHandler';

function AdministratorUserList() {
  const authenticationReducer = useSelector((state) => state.AuthenticationReducer);

  const columns = [
    {
      name: 'id',
      label: 'Référence',
      options: { filter: true, sort: true },
    },
    {
      name: 'email',
      label: 'Email',
      options: { filter: true, sort: true },
    },
    {
      name: 'firstname',
      label: 'Prénom',
      options: { filter: true, sort: true },
    },
    {
      name: 'lastname',
      label: 'Nom',
      options: { filter: true, sort: true },
    },
    {
      name: 'deposits',
      label: 'Dépots',
      options: { filter: true, sort: true },
    },
    {
      name: 'userFunction',
      label: 'Fonction utilisateur',
      options: { filter: true, sort: true },
    },
    {
      name: 'action',
      label: 'Action',
      options: { filter: false, sort: false },
    },
  ];
  const getAction = (row) => {
    return (
      <>
        <IconAction title="Modifier" icon="edit" to={getRoutePathname('administrator_user', { id: row.id })} />
        {(hasRight(authenticationReducer, 'ROLE_ADMINISTRATOR_USER') ||
          hasRight(authenticationReducer, 'ROLE_ADMINISTRATOR_USER_ARCHIVE')) && (
          <IconAction title="Supprimer l'utilisateur" icon="delete" onClick={() => archiveUser(row.id)} />
        )}
      </>
    );
  };

  const archiveUser = (userId) => {
    dispatch(LinearProgressMainLayoutActivate());

    ApiHandler.post(
      {
        route: 'api_administrator_user_archive',
        params: { id: userId },
      },
      (response) => {
        if (response.status === 200) {
          dispatch(
            SnackbarOpen({
              text: 'Utilisateur archivé avec succès.',
              variant: 'success',
            }),
          );
          window.location.reload();
        } else {
          dispatch(
            SnackbarOpen({
              text: response?.error?.message || "Une erreur inattendue s'est produite.",
              variant: 'error',
            }),
          );
        }

        dispatch(LinearProgressMainLayoutDeactivate());
      },
    );
  };

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Liste des utilisateurs', context: 'Administrateur' }}>
      <TableComponent
        id={'api_administrator_user_list'}
        title={'Utilisateurs'}
        columns={columns}
        actionFirst={
          hasRight(authenticationReducer, 'ROLE_ADMINISTRATOR_USER') ||
          hasRight(authenticationReducer, 'ROLE_ADMINISTRATOR_USER_ADD')
            ? {
                label: 'Ajouter un utilisateur',
                link: getRoutePathname('administrator_user', { id: 'add' }),
              }
            : false
        }
        promiseData={(resolve) => {
          ApiHandler.get({ route: 'api_administrator_user_list' }, (response) => {
            const data = response.data;
            for (const index in data) {
              data[index].action = getAction(data[index]);
            }
            resolve(data);
          });
        }}
      />
    </ContentViewComponent>
  );
}

export default AdministratorUserList;
